export const isMarlenkaTicketCode = (code: string) => {
  if(code){
    return code.match(/^\d{6}-\d{3}-\d{6,9}$/)?.length === 1;
  }
  return false;
}